<template>
    <main>
        <agile :navButtons=false>
            <img class="slide" src="http://www.shengjia-resin.com/temp/1.jpg" />
            <img class="slide" src="http://www.shengjia-resin.com/temp/2.jpg" />
            <img class="slide" src="http://www.shengjia-resin.com/temp/3.jpg" />
        </agile>
        <div class="article-wrapper">
            <article>
                <div v-html="content"></div>
            </article>
        </div>
    </main>
</template>

<script>
    import qs from 'qs';
    import {
        VueAgile
    } from 'vue-agile'
    export default {
        name: 'About',
        components: {
            agile: VueAgile
        },
        data() {
            return {
                content: '',
                datas: {},
                type: '公司介绍'
            }
        },
        mounted() {
            this.loadData();
        },
        methods: {
            loadData() {
                this.$axios.post('/findCompanyByType', qs.stringify({companyType:this.type})).then(res => {
                    this.datas = res.data;
                    if (this.datas != null) {
                        this.content = this.datas.content;
                    }
                }).catch(res => {
                    alert("数据获取失败")
                })
            }
        }
    }
</script>

<style lang="less">

</style>